import { useTranslation } from 'react-i18next';

export function CancelledResponseNotice() {
  const { t } = useTranslation();

  return (
    <p
      className="mt-3 border-t border-border/70 pt-2 text-xs leading-5 text-[#6D6D6D] dark:text-muted-foreground"
      role="status"
    >
      {t('RESPONSE_STOPPED', 'This response was stopped by the user.')}
    </p>
  );
}
